module.exports = __webpack_public_path__ + "img/ihosting.39412b53.png";